import { Controller } from "@hotwired/stimulus"
import { translations } from "../locales/pt-BR";

// Connects to data-controller="search-form-validation"
export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.validate.bind(this));
  }

  validate(event) {
    const inputs = this.element.querySelectorAll("input");

    inputs.forEach((input) => {
      input.setCustomValidity("");

      if (input.validity.badInput) {
        input.setCustomValidity(translations.invalid);
      } else if (input.validity.valueMissing) {
        input.setCustomValidity(translations.required);
      }

      if (!input.checkValidity()) {
        input.reportValidity();
        event.preventDefault();
      }
    });
  }
}
